import IPrayer from "../interfaces/IPrayer";
import IApiResponse from "../interfaces/IApiResponse";
import { PrayerStatusValues } from "../data/PrayerStatus";
import { isPlatform } from "@ionic/react";
import PrayerServiceWeb from "./web/PrayerServiceWeb";
import PrayerServiceHybrid from "./hybrid/PrayerServiceHybrid";

export interface IPrayerService {
    createPrayer: (prayer: IPrayer) => Promise<IApiResponse<IPrayer>>,
    getPrayer: (prayerId: number) =>  Promise<IApiResponse<IPrayer>>,
    getPrayersByStatus: (prayerStatus: PrayerStatusValues) =>  Promise<IApiResponse<IPrayer[]>>,
    getAllPrayers: () => Promise<IApiResponse<IPrayer[]>>,
    updatePrayer: (prayer: IPrayer, isSyncUpdate?: boolean) => Promise<IApiResponse<IPrayer>>,
    updatePrayers: (prayers: IPrayer[]) => Promise<IApiResponse<boolean>>,
    deletePrayer: (prayer: IPrayer) => Promise<IApiResponse<boolean>>,
}

const PrayerService: IPrayerService = {
    createPrayer: (prayer) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerService')
            return PrayerServiceHybrid.createPrayer(prayer);
        } else {
            console.log('WEB - PrayerService')
            return PrayerServiceWeb.createPrayer(prayer);
        }  
    },

    getPrayer: (prayerId) =>  {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerService')
            return PrayerServiceHybrid.getPrayer(prayerId);
        } else {
            console.log('WEB - PrayerService')
            return PrayerServiceWeb.getPrayer(prayerId);
        }  
    },

    getPrayersByStatus: (prayerStatus: PrayerStatusValues) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerService');
            return PrayerServiceHybrid.getPrayersByStatus(prayerStatus);
        } else {
            console.log('WEB - PrayerService')
            return PrayerServiceWeb.getPrayersByStatus(prayerStatus);
        } 
    },

    getAllPrayers: () => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerService')
            return PrayerServiceHybrid.getAllPrayers();
        } else {
            console.log('WEB - PrayerService')
            return PrayerServiceWeb.getAllPrayers();
        } 
    },

    updatePrayer: (prayer, isSyncUpdate?) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerService - update')
            return PrayerServiceHybrid.updatePrayer(prayer, isSyncUpdate);
        } else {
            console.log('WEB - PrayerService')
            return PrayerServiceWeb.updatePrayer(prayer, isSyncUpdate);
        } 
    },

    updatePrayers: (prayers) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerService')
            return PrayerServiceHybrid.updatePrayers(prayers);
        } else {
            console.log('WEB - PrayerService')
            return PrayerServiceWeb.updatePrayers(prayers);
        } 
    },

    deletePrayer: (prayer) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - PrayerService')
            return PrayerServiceHybrid.deletePrayer(prayer);
        } else {
            console.log('WEB - PrayerService')
            return PrayerServiceWeb.deletePrayer(prayer);
        } 
    },
}

export default PrayerService;